import React from 'react'
import Snackbar from '@material-ui/core/Snackbar'
import MuiAlert from '@material-ui/lab/Alert'
import { makeStyles } from '@material-ui/core/styles'

function Alert(props) {
   return <MuiAlert elevation={6} variant="filled" {...props} />
}

const useStyles = makeStyles(theme => ({
   root: {
      marginTop: '20px',
      position: 'absolute',
      width: '100%',
      '& > * + *': {
         marginTop: theme.spacing(2)
      }
   }
}))

// TODO: eliminar
export default function Snackbars(props) {
   const classes = useStyles()
   const [open, setOpen] = React.useState(true)
   const handleClose = (event, reason) => {
      if (reason === 'clickaway') {
         return
      }
      setOpen(false)
   }

   // error warning info success
   return (
      <div className={classes.root}>
         <Snackbar
            style={{ width: '100%' }}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={props.open || open}
            autoHideDuration={props.duration || 5000}
            onClose={props.onClose || handleClose}
         >
            <Alert
               onClose={props.onClose || handleClose}
               severity={props.severity}
               style={{
                  width: '100%',
                  marginTop: '30px',
                  color: props.fontColor
               }}
            >
               {props.message}
            </Alert>
         </Snackbar>
      </div>
   )
}
